module.exports = __webpack_public_path__ + "static/media/30-2.f38686a2.mp3";